import { busk } from './articleService';

const api = process.env.REACT_APP_API_URL;
const REPORT_ROUTE = api + '/reports';

export const setReportService = async (data) => {
  const token = await localStorage.getItem('_token');
  return busk(token).post(`${REPORT_ROUTE}`, data);
};
